module.exports = __webpack_public_path__ + "static/laser_lg-03e6bd69c3dd26e61c68af52103f6757.webp";